import { render } from "./prp-expired.vue?vue&type=template&id=0890b0c1&scoped=true"
import script from "./prp-expired.vue?vue&type=script&lang=js"
export * from "./prp-expired.vue?vue&type=script&lang=js"

import "./prp-expired.vue?vue&type=style&index=0&id=0890b0c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0890b0c1"]])

export default __exports__